export default {
  NewChatMessage : 'NewChatMessage',
  ChatMessage : 'ChatMessage',
  ChatMessageRead : 'ChatMessageRead',
  OpenPromotion : 'OpenPromotion',
  ViewRecommendation : 'ViewRecommendation',
  ChatTyping : 'ChatTyping',
  OpenChatSentFromMassletter : 'OpenChatSentFromMassletter',
}